<template>
<div class="main">
  <div class="container">
    <!-- Content here -->
    <div class="card agreement">
      <div class="card-body" id="content">
      </div>
    </div>
  </div>
  <Footer/>
</div>
</template>

<script>
import Footer from 'components/footer'
import {lang} from 'lang'
import marked from 'marked'
import axios from 'axios'

export default {
  name: 'app',
  components: {
    Footer
  },
  data () {
    return {
    }
  },
  mounted () {
    const fileName = lang === 'en' ? '/static/doc/泛函科技隐私政策-en.md' : '/static/doc/泛函科技隐私政策.md'
    axios.get(fileName).then(
      res => {
        const { data } = res
        this.$nextTick(() => {
          const test = document.querySelector('#content')
          test.innerHTML = marked(data)
        })
        console.log(res)
      }
    )
  }
}
</script>

<style lang="less" scoped>
/deep/.card-body h3 {
  text-align: center;
}
/deep/.card-body > p {
  text-indent: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/agreement/privacy/app.vue